import {
    component,
    CustomObjectContextData,
    EntityData,
    field,
    identifier,
    LocalisableEntityData
} from "@fedeltapointofsale/data-client";
import {PointsData} from "../points/points.data";

export class RewardRateData extends EntityData<RewardRateData> {
    @component rewardRate: PointsData;
}

export class MembershipTypeData extends LocalisableEntityData<MembershipTypeData> {
    @identifier membershipTypeId: number;
    @field name: string;
    @field discontinued: boolean;
    @field description: string;
    @field thirdPartyId: string;
    @field requiresPO: boolean;
    @field chargeAssociatedAccountOnly: boolean;

    @field wholePointsOnlyOnAccrual: boolean;
    @field roundOnSaleTotal: boolean;
    @field priceLevelId: number;
    @field discountId: number;
    @field pointsExpiryDays: number;
    @component customObjectContext: CustomObjectContextData;
    @component accrualRewardRate: RewardRateData;
    @component redemptionRewardRate: RewardRateData;
}

export class MembershipTypeReferenceData extends LocalisableEntityData<MembershipTypeReferenceData> {
    @identifier membershipTypeId: number;
    @field name: string;
}
